// extracted by mini-css-extract-plugin
module.exports = {"main":"ResultsHeader_main__SigHm","count":"ResultsHeader_count__eBgYs","number":"ResultsHeader_number__s2vuJ"};